import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './InsuranceModal.css';

const InsuranceModal = ({ isOpen, onClose }) => {
  React.useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    
    // Cleanup function to remove the class when component unmounts
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const insuranceProviders = [
    'Aetna',
    'Allied Benefits System',
    'Blue Cross Blue Shield (AKA BCBS, Anthem, Regence, etc.)',
    'Cigna',
    'ChampVA',
    'Fenyx (Medicare)',
    'GEHA (where UHC is payor, PO Box 30555)',
    'Government issued Medicare (No Managed Care Plans)',
    'Healthscope',
    'Hometown Health',
    'Luminare (previously Trustmark)',
    'Medicare Supplemental Plans',
    'Nevada State Medicaid (No Managed Care Plans)',
    'Operating Engineers',
    'Optum',
    'Sierra Optima',
    'Simplified Benefits',
    'Surest (Bind Benefit)',
    'Tricare/Triwest',
    'UC Health',
    'UMR',
    'United Healthcare (UHC)',
    '90 Degree'
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Accepted Insurance Providers</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-body">
          <ul className="insurance-list">
            {insuranceProviders.map((provider, index) => (
              <li key={index} className="provider-item">
                {provider}
              </li>
            ))}
          </ul>
          <p className="contact-note">
            Don't see your insurance listed?<br />
            Contact us to verify your coverage options.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InsuranceModal;
